import type { ReactNode } from "react";
import Icon from "../Icon/Icon";
import "./PeopleList.css";

export interface PeopleListItem {
  key: string;
  name: ReactNode;
  /** short status line, for example "Profile completed" */
  status: ReactNode;
  /** letter in the round badge */
  initial: string;
  active?: boolean;
  complete?: boolean;
}

export interface PeopleListProps {
  people: PeopleListItem[];
}

/** People in one application (you, guarantors, co-tenants) on the dark rail. */
const PeopleList = ({ people }: PeopleListProps) => (
  <ul className="ds-people">
    {people.map((person) => (
      <li
        key={person.key}
        className={`ds-people__item${person.active ? " is-active" : ""}${
          person.complete ? " is-complete" : ""
        }`}
      >
        <span className="ds-people__avatar">{person.initial}</span>
        <div className="ds-people__text">
          <strong>{person.name}</strong>
          <span>{person.status}</span>
        </div>
        {person.complete && (
          <span className="ds-people__check">
            <Icon name="check" size={14} />
          </span>
        )}
      </li>
    ))}
  </ul>
);

export default PeopleList;
